/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
    $(".image_with_video .video_main_icon").click(function(){
      $(".page-gold-main-image").show();
      $(".image_with_video .video-section").hide();
      $(".image_with_video .video-section video").trigger("pause");
      $(this).parents(".page-gold-main-image").hide();
      $(this).parents(".image_with_video").find(".video-section").show();
      $(this).parents(".image_with_video").find(".video-section video").trigger("play");
    });
    
    	$(window).on("load resize",function(e){
    var screenwidth = $( window ).outerWidth();
	var containerwidth = $('.wrapper--full').width();
	var calculated = screenwidth - containerwidth;
	var finalval = calculated/2;
	$('.image_video_content .image_video_text').css('padding-left',finalval+"px");
	
	});


 function mobileOnlySlider() {
    $('.testi_mobile_slider').slick({
      autoplay: true,
      speed: 1000,
      adaptiveHeight: true,
      autoplaySpeed: 5000,
      arrows:true,
      prevArrow:'<div class="slick-prev"><svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.19531 6.1875L6.9375 0.40625C7.17188 0.171875 7.39323 0.171875 7.60156 0.40625L8.38281 1.14844C8.59115 1.38281 8.59115 1.60417 8.38281 1.8125L3.73438 6.5L8.38281 11.1875C8.59115 11.3958 8.59115 11.6172 8.38281 11.8516L7.60156 12.5938C7.39323 12.8281 7.17188 12.8281 6.9375 12.5938L1.19531 6.8125C0.986979 6.60417 0.986979 6.39583 1.19531 6.1875Z" fill="#696969"/></svg></div>',
      nextArrow:'<div class="slick-next"><svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.80469 6.1875L2.0625 0.40625C1.82812 0.171875 1.60677 0.171875 1.39844 0.40625L0.617188 1.14844C0.408854 1.38281 0.408854 1.60417 0.617188 1.8125L5.26562 6.5L0.617188 11.1875C0.408854 11.3958 0.408854 11.6172 0.617188 11.8516L1.39844 12.5938C1.60677 12.8281 1.82812 12.8281 2.0625 12.5938L7.80469 6.8125C8.01302 6.60417 8.01302 6.39583 7.80469 6.1875Z" fill="#696969"/></svg> </div>',
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }

$( document ).ready(function() {
  
    if ($(window).width() > 1024) {
      $(".scrolling-header .search-main-main").remove();
   $(".search-main-main").insertAfter(".inasert_data_here");
      $(".search-main-main").show();
  }
  $("a.main_search_icon").click(function(e){
    e.preventDefault();
    $(".search-main-main").slideToggle();
  });
  
  
  
  setTimeout(function(){
  $(".cf-widget-video-slider .cf-slider-arrow").insertAfter(".cf-widget-items-wrapper");
  },500);
$(".main_faq_page .accordion h4.accordion__title").eq(0).trigger("click");

  

  setTimeout(function(){
    $(".triiger-2").trigger("click");

  }, 500);


//   $(".collection__sidebar__slider ").removeClass("expanding");
//   $(".collection__sidebar__slider ").removeClass("expanded");
 
  if(window.innerWidth < 768) {
    mobileOnlySlider();
  }

  $(window).resize(function(e){
    if(window.innerWidth < 768) {
      if(!$('.testi_mobile_slider').hasClass('slick-initialized')){
        mobileOnlySlider();
      }

    }else{
      if($('.testi_mobile_slider').hasClass('slick-initialized')){
        $('.testi_mobile_slider').slick('unslick');
      }
    }
    if ($(window).width() > 1024) {
      $(".scrolling-header .search-main-main").remove();
      $(".search-main-main").insertAfter(".inasert_data_here");
      $(".search-main-main").show();
    }
    if  ($(window).width() < 1025){
      $(".scrolling-header .search-main-main").remove();
       $(".search-main-main").insertAfter(".header__desktop");
      $(".search-main-main").hide();
    }
  });




  $(window).resize(function(){

    var width = $( window ).width();
    if(width > '748'){
      $('.footer__block__title').parents(".links-footer").find("ul.footer__quicklinks").show();

    }else{
      //       $('.footer__block__title"').parents(".links-footer").find("ul.footer__quicklinks").hide();

    }

  });
  $("body").on("click",".footer__block__title", function(e){
    e.preventDefault();
    var width = $( window ).width();
    if(width <='748'){
      $('.footer__block__title').not(this).parents(".links-footer").find("ul.footer__quicklinks").hide();
      $('.footer__block__title').not(this).parents(".links-footer").removeClass("active");
      $('.footer__block__title').not(this).removeClass("active");
      $(this).parents(".links-footer").find("ul.footer__quicklinks").slideToggle();
      $(this).parents(".links-footer").toggleClass("active");
      $(this).toggleClass("active");



    } 
  });

  var size_li = $(".cstm_collection_item .cstm_product_item").length;  
  var x= 12;
  $(".cstm_collection_item .cstm_product_item").slice(0, x).show();
  $("body").on("click","#loadMore", function(e){
    e.preventDefault();
    //x= (x+12 <= size_li) ? x+12 : size_li;
    if(x<size_li){
      var next = x+12;
    }else{
      var next =size_li;
    }

    $(".cstm_collection_item .cstm_product_item:hidden").slice(0, 12).show();
    var data_count = $(".cstm_product_item.product-item:visible").length;
    $("span.show_count").text(data_count);
    x=next;

    if (x>=size_li) {
      $("#loadMore").fadeOut('slow');
    }

  });






  var $buttonPlus = $('.increase-btn');
  var $buttonMin = $('.decrease-btn');
  var $quantity = $('.quantity');

  /*For plus and minus buttons*/
  $buttonPlus.click(function() {
    $quantity.val(parseInt($quantity.val()) + 1).trigger('button');
  });

  $buttonMin.click(function() {
    $quantity.val(Math.max(parseInt($quantity.val()) - 1, 0)).trigger('button');
  });

  $("form .cstm_size span.radio__button input").change(function(){
    var size = $(this).val();
    $(this).parents("fieldset.radio__fieldset").find(".cstm_size_text").html(size);
    var text ='';
    $(this).parents(".product-form").find(".cstm_size span.radio__button input").each(function(){
      if ($(this).is(":checked"))
      {
        text += $(this).attr("data-value")+" / ";
      }
    });
    var newname = text.slice(0,-2).trim();
    
    var main_sku = $(this).parents(".product-form").find(".product__form__select option[var-title='"+newname+"']").attr("data-sku");
    var main_qty = $(this).parents(".product-form").find(".product__form__select option[var-title='"+newname+"']").attr("data-quantity");
    var main_val = $(this).parents(".product-form").find(".product__form__select option[var-title='"+newname+"']").val();
    var main_price = $(this).parents(".product-form").find(".product__form__select option[var-title='"+newname+"']").attr("data-price");
    //$(".product__price span").text(main_price);
     $(".product__price > span").text(main_price);
  $(".product__submit__add.add_cart_btn").attr("data-id",main_val)
    if(main_sku != '' && typeof main_sku !== "undefined"){
      $(".product_sku ").html(" <p><span>SKU: </span> <span class='append_data'>"+main_sku+"</span><p>");
      $(".product_sku").show();
    }else{
    $(".product_sku").hide();
    }
    if(typeof main_qty !== "undefined" ){
      if(main_qty > 0){
        $(".product__submit__add span").text("Add To Cart");
        $(".product__submit__add").removeAttr("disabled");
         $(".product__submit__add").addClass("add_cart_btn");
        $(".form__wrapper").removeClass("variant--unavailable")
      }else{
        $(".product__submit__add span").text("Sold Out");
        $(".product__submit__add").attr("disabled","disabled");
        $(".product__submit__add").removeClass("add_cart_btn");
        $(".form__wrapper").addClass("variant--unavailable")
      }
    }else{
      $(".product__submit__add span").text("Unavailable");
        $(".product__submit__add").attr("disabled","disabled");
      $(".product__submit__add").removeClass("add_cart_btn");
      $(".form__wrapper").addClass("variant--unavailable")
    }
  });

  $('.tabs-nav a:first-child').addClass('active');
  $('.tabcontent').hide();
  $('.tabcontent:first').show();
  $('.tabs-nav a').click(function(){
    $('.tabs-nav a').removeClass('active');  
    $(this).addClass('active');
    $('.tabcontent').hide();
    var activeTab = $(this).attr('href');

    $(activeTab).show();
    return false;
  });

  $(".cstm_quant_cart").on("button", ".quantity", function() {
    var price = +$(".price").data("price");
    var quantity = +$(this).val();
    $("#total").text("$" + price * quantity);
  })

  $(".cstm_size.product__selectors .selector-wrapper").each(function(){

    var size = $(this).find("span.radio__button input:checked").val();
    $(this).find(".cstm_size_text").html(size);

  });

  if ($(window).width() < 992){
    $(".collection__sidebar__slider").removeClass("expanded");
  }
var main_qty = $(".product-form .product__form__select option:selected").attr("data-quantity");
if(typeof main_qty !== "undefined" ){
if(main_qty > 0){
$(".product__submit__add span").text("Add To Cart");
$(".product__submit__add").removeAttr("disabled");
$(".product__submit__add").addClass("add_cart_btn");
  $(".form__wrapper").removeClass("variant--unavailable")
}else{
$(".product__submit__add span").text("Sold Out");
$(".product__submit__add").attr("disabled","disabled");
$(".product__submit__add").removeClass("add_cart_btn");
  $(".form__wrapper").addClass("variant--unavailable")
}
}else{
$(".product__submit__add span").text("Unavailable");
$(".product__submit__add").attr("disabled","disabled");
$(".product__submit__add").removeClass("add_cart_btn");
  $(".form__wrapper").addClass("variant--unavailable")
}
});



$(window).resize(function(){
  if ($(window).width() < 992){
    $(".collection__sidebar__slider").removeClass("expanded");
  }else{
    $(".collection__sidebar__slider").addClass("expanded");
  }
});


$(".cros_btn").click(function(){
  $(".collection__sidebar__slider").removeClass("expanded");
});

// $("body").on("click", ".cros_btn", function(e) {
//     e.preventDefault();
     
//      if($(".collection__sidebar__slider").hasClass("expanded")){
//        $(".collection__sidebar__slider").removeClass("expanding");
//        $(".collection__sidebar__slider").removeClass("expanded");
//        $(".cstm_collection_item").find(".popout__toggle").attr("aria-expanded","false");
//      }else{
//          $(".collection__sidebar__slider").addClass("expanding");
//        $(".collection__sidebar__slider").addClass("expanded");
//        $(".cstm_collection_item").find(".popout__toggle").attr("aria-expanded","true");
    
       
//      }
     
     
// });
// if($(".stamped-badge-caption").length > 0){
//   setTimeout(function() {
//     var hhStamp = $(".stamped-badge-caption").html();

//     var retArray = hhStamp.split("<span");
//     var value = retArray[0];
//     var newValue = "("+value+")<span class='hide-val'  "+retArray[1];
//     $(".stamped-badge-caption").html(newValue);
//   }, 2000);


// }
// const myInterval = setInterval(reviews, 1000);

// function reviews() {
//   $(".cstm_product_item").each(function(){
//     var data_review = $(this).find("span.stamped-badge-caption").attr("data-reviews");
//     $(this).find("span.stamped-badge-caption").text("("+data_review+")");
//   });
// }

// function myStopFunction() {
//   clearInterval(myInterval);
// }




// $(document).on("click",".sidebar__item",function() {
//    setTimeout(function() {
//     location.reload();
//    },1000);

// });


$(window).on("load resize",function(e){ 
  var height =  jQuery('.image_with_video .inner').outerHeight();
  jQuery( '.slide-image.image_main_slider' ).css({ 'height': 'calc(100% - ' + height+ 'px)' });
  jQuery( '.main_video_slider' ).css({ 'height': 'calc(100% - ' + height+ 'px)' });
  
  
  
  
  
  var screenwidth = $( window ).outerWidth();
	var containerwidth = $('.wrapper--full').width();
	var calculated = screenwidth - containerwidth;
	var finalval = calculated/2;
	$('.banner-content .brick__block__text').css('padding-left',finalval+"px");
  });

$(document).on("click",".popout-list__item",function(){
    setTimeout(function(){
   $("#loadMore").trigger("click");
    },2000);
});


// (function() {
//   var init = function() {
//     var css = ".scrolling-header{position: fixed; top: 0px; left: 0px; width: 100%; height: 160px; transition: transform .15s ease; overflow: visible;z-index:99 !important} .scrolling-header.scroll-up{overflow: visible;} .scrolling-header.scroll-down{ transform: translateY(-160px); overflow: hidden;}";
//     $("body").append("<style>" + css + "</style>");
// //    var duplicated = $("#shopify-section-header, .header__dropdown").clone(true, true);

//     duplicated.addClass("scrolling-header");

//     $("body").append(duplicated);
//     var lastScrollTop = $(window).scrollTop();
//     $(window).on("scroll", function() {
//       var currentScrollTop = $(window).scrollTop();
//       if (currentScrollTop > lastScrollTop || currentScrollTop <= 0) { //scroll down
//         $(".scrolling-header").removeClass("scroll-up").addClass("scroll-down")
//       } else {
//         $(".scrolling-header").removeClass("scroll-down").addClass("scroll-up")
//       }
//       lastScrollTop = currentScrollTop;
//     });
//   };

//   var waitForDepenencies = function() {
//     if (typeof $ == "undefined" || $("#shopify-section-header").length <= 0) {
//       setTimeout(waitForDepenencies, 500);
//     } else {
//       init();
//     }
//   };
//   waitForDepenencies();

// })();

var lastScrollTop = 0;
     var css = ".Header--fixed{position: fixed; top: 0px; left: 0px; width: 100%; transition: transform .15s ease; overflow: visible} .scrolling-header.scroll-up{overflow: visible;} .scrolling-header.scroll-down{ transform: translateY(-160px); overflow: hidden;}";
     $("body").append("<style>" + css + "</style>");

$(window).scroll(function (t) {
    var e = $(this).scrollTop(),
        i = $(".theme__header");
    e <= 20 ? (i.removeClass("Header--fixed"), i.removeClass("Scroll__up_header")) : e > lastScrollTop ? (i.removeClass("Header--fixed"), i.addClass("Scroll__up_header")) : (i.addClass("Header--fixed"), i.removeClass("Scroll__up_header")),
        (lastScrollTop = e);
});
$(".scrolling-header .menu__item").mouseover(function(){
    $(".menu__item").removeClass("is-visible");
    $(".header__dropdown").removeClass("is-visible");
$(this).addClass("is-visible");
$(this).find(".header__dropdown").addClass("is-visible");
});
$(".scrolling-header .menu__item").mouseleave(function(){
    $(".menu__item").removeClass("is-visible");
    $(".header__dropdown").removeClass("is-visible");
});

$(".product_var_here .cstm_size.product__selectors span.radio__button input").change(function(){

  var dataval = $(this).val();
  $(".product__form .cstm_size.product__selectors  span.radio__button input[value='"+dataval+"']").trigger("click");
});



		$(window).on("load resize",function(e){
      
      var anno_height  =  jQuery('div#shopify-section-announcement').outerHeight();
      var head_height  =  jQuery('.header__desktop__upper').outerHeight();
var num = 1;
      var total_anno_head = anno_height + head_height + num ;
     // alert(total_anno_head);
      jQuery( '.top_nav_wrapper ul.menu li.menu-link .megamenu_wrapper' ).css( 'top',total_anno_head); 
      
       });
      
$(".menu-link").hover(function(){
        get_div = $(this).children('.megamenu_wrapper').length;
        if(get_div == 1){
            $(".megamenu_wrapper").hide();
   $(this).parent().find('.megamenu_wrapper').show();
        }else{
   $('.megamenu_wrapper').hide();

            
        }
    
});


  $(document).on('mouseleave', '.megamenu_wrapper', function () {
       $(this).hide();

  });

$(".menu__item").hover(function(){
   $('.megamenu_wrapper').hide();
});
    $( ".search__popdown__upper input" ).click(function() {

   $('.megamenu_wrapper').hide();
});
$(".cart__icon__content").click(function(){
   $('.megamenu_wrapper').hide();
});

$(".select-popout__list li").click(function(){
var url      = window.location.href; 
var parts = url.split("=");
    var    last_part = parts[parts.length-1];
        $(".product__form__select").val(last_part);
      var check_availble = $(".product__form__select option:selected").attr('data-available');
      if(check_availble == 'yes' ){
        $("a.btn.klaviyo-bis-trigger").hide();
      }else{
              $("a.btn.klaviyo-bis-trigger").show();
      }
});
$(document).ready(function(){

var divCheckingInterval = setInterval(function(){
    // Find it with a selector
    if( document.querySelector("#address_country")  != null && document.querySelector("#address_country").length < 1 ){
 if(document.querySelector("#address_country").length == '237'){
       var select = document.querySelector('#address_country');
    select.value = 'US';

    /* since programatically changes won't fire the change event,
       we need to do it ourselves */
    var event = document.createEvent("HTMLEvents");
    event.initEvent("change",true,false);
    select.dispatchEvent(event);
        clearInterval(divCheckingInterval);
        // Do something
    }
    }
}, 500);
});

$(".menu__item.parent").on("mouseover", function () {
$(this).find(".main_drop_desktop_menu .megamnu_image_inner").each(function(){
var data_src = $(this).find(".image_wrapper img").attr("data-src");
$(this).find(".image_wrapper img").attr("src",data_src);  
});
});

$(".cart-bar__submit").on("click", function() {
    var productid =  $("form .product__submit__add.add_cart_btn").attr('data-id');
    var data_qty = $("input.quantity__input").val();
    jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: productid,
                quantity: data_qty
            },
            dataType: 'json',
            success: function(productid) {

                jQuery.ajax({
                    type: 'GET',
                    url: '/cart',
                    dataType: 'html',
                    success: function(cart) {
                        window.location.replace("/cart");
                    },
                });
            }
    });
});

$(".product__submit__add.add_cart_btn").click(function(e){
e.preventDefault();
var productid = $(this).attr('data-id');
var data_qty = $("input.quantity__input").val();
jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data:{
id: productid,
quantity: data_qty
},
dataType: 'json',
success: function(productid){

jQuery.ajax({
type: 'GET',
url: '/cart',
dataType: 'html',
success: function(cart){
window.location.replace("/cart");
},
});
},
});
});

   //console.clear();
